const SERVICE_NAME_FILTER_PATHS = new Set([
  "/myDocuments",
  "/Request/Library",
  "/Documents",
  "/documents/RFI",
  "/Documents/Audit",
]);

export function getFilterOptionServiceName(option) {
  return option?.services || option?.rfi_name || option?.name;
}

/**
 * Canonical option id used when toggling filter checkboxes.
 * Desktop/mobile previously passed args in different orders; keep one resolver.
 */
export function resolveFilterOptionId({
  currentPath,
  sectionId,
  docId,
  statusID,
  id,
  rfi_id,
  vqa_auditor_id,
  hash_id,
  service_name,
}) {
  if (
    SERVICE_NAME_FILTER_PATHS.has(currentPath) &&
    sectionId === "services" &&
    service_name
  ) {
    return service_name;
  }

  return docId || statusID || id || rfi_id || vqa_auditor_id || hash_id;
}

export function getFilterCheckboxHandlerArgs(option) {
  return [
    option?.docId,
    option?.statusID,
    option?.id,
    option?.rfi_id,
    option?.vqa_auditor_id,
    option?.hash_id,
    getFilterOptionServiceName(option),
  ];
}

/** Reset every selectedIds key to [] while preserving key shape. */
export function resetSelectedFilterIds(selectedIds) {
  return Object.keys(selectedIds || {}).reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {});
}

/** Per-section selection counts for filter button badges. */
export function getSelectedFilterCounts(selectedIds) {
  return Object.fromEntries(
    Object.entries(selectedIds || {}).map(([key, ids]) => [
      key,
      Array.isArray(ids) ? ids.length : 0,
    ])
  );
}

/** True when any filter section has at least one selected id. */
export function hasAnySelectedFilterIds(selectedIds) {
  return Object.values(selectedIds || {}).some(
    (ids) => Array.isArray(ids) && ids.length > 0
  );
}

export function isFilterOptionChecked({
  currentPath,
  sectionId,
  selectedIds,
  option,
}) {
  const selected = selectedIds?.[sectionId];
  if (!selected?.length) {
    return false;
  }

  if (SERVICE_NAME_FILTER_PATHS.has(currentPath) && sectionId === "services") {
    const serviceName = getFilterOptionServiceName(option);
    const optionId = option?.rfi_id || option?.id || option?.hash_id;
    return selected.includes(serviceName) || selected.includes(optionId);
  }

  const valueToCheck =
    option?.docId ||
    option?.statusID ||
    option?.id ||
    option?.rfi_id ||
    option?.vqa_auditor_id ||
    option?.hash_id;

  return selected.includes(valueToCheck);
}
